import { FormControl } from '@angular/forms';

export type ModelFormGroup<T> = {
  [K in keyof T]: FormControl<T[K]>;
};
